import { render, staticRenderFns } from "./ArtificialAgentAdmin.vue?vue&type=template&id=60ac4d65"
import script from "./ArtificialAgentAdmin.vue?vue&type=script&lang=js"
export * from "./ArtificialAgentAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports